// CC: Selective Mailbox Protection (inbound_relay.addresses_only) - shared by Plan Settings > Email Flow Integration and the
// onboarding wizard's "Protected Mailboxes" sub-step. Taken from inbound-email-relay-integration.component.ts (addAddress / removeAddress / addAddressFromFile).
import * as util from 'util';
import {Component, Input, OnChanges} from '@angular/core';
import {GeneralService} from '../../../../../../services/generalService';
import {RouteService} from '../../../../../../services/routeService';
import {NotificationService} from '../../../../../../services/notificationService';
import {DICTIONARY} from '../../../../../../dictionary';

@Component({
	selector: 'selective-mailbox-protection-component',
	templateUrl: './selective-mailbox-protection.component.html',
})
export class SelectiveMailboxProtectionComponent implements OnChanges {
	@Input() relay: any; // plan.inbound_relay
	@Input() hideTitle = false; // CC: the wizard sub-step already shows the title and explanation
	// CC: the toggle's <label for> targets an element id; the wizard can be opened on top of Plan Settings, so each instance needs its own id
	@Input() idPrefix = '';

	dic = DICTIONARY;
	corpname = this.gs.corpname;
	newAddress = '';
	inProcess = false;

	constructor(public gs: GeneralService,
				private rs: RouteService,
				private ns: NotificationService) {
	}

	ngOnChanges() {
		if (this.relay && !this.relay.addresses_only) {
			this.relay.addresses_only = [];
		}
	}

	updateSkipMode = () => {
		this.inProcess = true;
		const updateData = {
			action: this.dic.CONSTANTS.inboundRelayActions.addressSkipMode,
			enabled: this.relay.addresses_only_skip_mode
		};
		this.rs.activateInboundEmailRelayAndGenKey(updateData).then(() => {
			this.inProcess = false;
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
		}, () => {
			this.inProcess = false;
			this.relay.addresses_only_skip_mode = !this.relay.addresses_only_skip_mode;
		});
	}

	addAddress = () => {
		const address = (this.newAddress || '').trim();
		if (!this.gs.validateEmail(address)) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.invalidEmail, address));
			return;
		}
		if (this.relay.addresses_only.includes(address.toLowerCase())) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.emailAlreadyExist, address));
			return;
		}
		this.addAddresses([address]);
	}

	// CC: one request for the whole list (the backend expands groups and dedupes; `addresses` array contract, BackEnd #15633)
	addAddresses = (addresses) => {
		if (this.inProcess) {
			return;
		}
		this.inProcess = true;
		const updateData = {
			action: this.dic.CONSTANTS.inboundRelayActions.address,
			type: this.dic.CONSTANTS.actions.add,
			addresses
		};
		this.rs.activateInboundEmailRelayAndGenKey(updateData).then((response) => {
			this.inProcess = false;
			this.relay.addresses_only = response.addresses_only || [];
			this.newAddress = '';
			this.ns.showInfoMessage(addresses.length > 1 ? `${addresses.length} addresses added` : this.dic.MESSAGES.changedSuccessfully);
		}, () => {
			this.inProcess = false;
		});
	}

	removeAddress = (address) => {
		if (this.inProcess) {
			return;
		}
		this.inProcess = true;
		const updateData = {
			action: this.dic.CONSTANTS.inboundRelayActions.address,
			type: this.dic.CONSTANTS.actions.delete,
			address
		};
		this.rs.activateInboundEmailRelayAndGenKey(updateData).then(() => {
			this.inProcess = false;
			this.relay.addresses_only = this.relay.addresses_only.filter(itm => itm !== address);
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
		}, () => {
			this.inProcess = false;
		});
	}

	addAddressesFromFile = () => {
		this.gs.showPopup({
			title: 'Import List',
			subTitle: 'To ensure ' + this.corpname + ' can successfully handle your list, it should meet the following conditions:',
			body: [
				'File type must be a Comma Separated Value (.csv)',
				'Email addresses should appear in the Emails column and only there',
			],
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'OK',
			isFile: true,
			doneCb: (files) => {
				if (!files || !files.length) {
					return;
				}
				if (files[0].name && !files[0].name.toLowerCase().endsWith('.csv')) {
					this.ns.showErrorMessage('Expected .csv file');
					return;
				}

				this.gs.readCsv(files[0], ['emails'], [], this.dic.CONSTANTS.EMAIL_REGEX, [this.gs.validateEmail], (err, res) => {
					if (err) {
						console.error(err);
						return;
					}
					const addresses = res.emails.filter(address => !this.relay.addresses_only.includes(address.toLowerCase()));
					if (!addresses.length) {
						this.ns.showWarnMessage('No new addresses found in the file');
						return;
					}
					this.addAddresses(addresses);
				});
			}
		});
	}
}
